(function () {
  'use strict';

  if (window.AxiomFreeShippingBar) return;

  var selector = '[data-free-shipping-bar]';
  var latestCart = null;
  var initialCartRequest = null;

  function formatMoney(cents) {
    var formatted;
    if (window.Axiom && typeof window.Axiom.formatMoney === 'function') {
      formatted = window.Axiom.formatMoney(cents);
    } else {
      return String(cents);
    }

    var moneyFormat = String(window.Axiom.moneyFormat || '{{amount}}');
    var placeholder = (moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
    if (placeholder.indexOf('no_decimals') !== -1) return formatted;

    var decimalSeparator = placeholder === 'amount_with_comma_separator' || placeholder === 'amount_with_space_separator'
      ? ','
      : '.';
    var escapedSeparator = decimalSeparator === '.' ? '\\.' : ',';
    return formatted.replace(new RegExp(escapedSeparator + '00(?=\\D|$)'), '');
  }

  function replaceAmount(template, amount) {
    return String(template || '').split('{amount}').join(amount);
  }

  function cartTotalCents(cart) {
    if (!cart) return 0;

    // The Standard Cart API exposes money as cost.totalAmount.amount in major
    // currency units, while the Ajax Cart API exposes total_price in cents.
    // Normalize both documented response shapes before calculating progress.
    if (cart.cost && cart.cost.totalAmount && cart.cost.totalAmount.amount != null) {
      var amount = Number(cart.cost.totalAmount.amount);
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    }

    var totalPrice = Number(cart.total_price);
    return Number.isFinite(totalPrice) ? totalPrice : 0;
  }

  // Theme settings hold the threshold in the store currency. Cart totals are in
  // the shopper's currency, so convert with the rate Shopify exposes for it.
  function thresholdInCartCurrency(instance) {
    var threshold = Number(instance.dataset.thresholdCents || 0);
    var currency = window.Shopify && window.Shopify.currency;
    var storeCurrency = instance.dataset.thresholdCurrency || '';
    if (!currency || !currency.active || !storeCurrency || currency.active === storeCurrency) return threshold;
    var rate = Number(currency.rate);
    return rate > 0 ? Math.round(threshold * rate) : threshold;
  }

  function updateLiveRegion(instances) {
    var liveInstance = instances.find(function (instance) {
      return instance.closest('[data-quick-view-modal][aria-hidden="false"]');
    }) || instances.find(function (instance) {
      return instance.getClientRects().length > 0;
    }) || null;

    instances.forEach(function (instance) {
      var message = instance.querySelector('[data-free-shipping-message]');
      if (!message) return;
      message.setAttribute('aria-live', instance === liveInstance ? 'polite' : 'off');
    });
  }

  function updateInstance(instance, cart) {
    if (!instance || !cart) return;

    var threshold = thresholdInCartCurrency(instance);
    if (threshold <= 0) return;

    var total = Math.max(0, cartTotalCents(cart));
    var remaining = Math.max(0, threshold - total);
    var progress = Math.min(100, Math.max(0, total / threshold * 100));
    var reached = total >= threshold;
    var message = instance.querySelector('[data-free-shipping-message]');
    var progressbar = instance.querySelector('[data-free-shipping-progress]');
    var template = reached
      ? instance.dataset.successTemplate
      : instance.dataset.progressTemplate;

    if (message) {
      message.innerHTML = reached ? String(template || '') : replaceAmount(template, formatMoney(remaining));
    }

    instance.style.setProperty('--free-shipping-progress', progress + '%');
    if (progressbar) progressbar.setAttribute('aria-valuenow', String(Math.round(progress)));
  }

  function updateAll(cart, scope) {
    if (cart) latestCart = cart;
    if (!latestCart) return;

    var root = scope && scope.querySelectorAll ? scope : document;
    var instances = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) instances.unshift(root);

    instances.forEach(function (instance) {
      updateInstance(instance, latestCart);
    });
    updateLiveRegion(Array.prototype.slice.call(document.querySelectorAll(selector)));
  }

  function requestInitialCart() {
    if (latestCart) return Promise.resolve(latestCart);
    if (initialCartRequest) return initialCartRequest;
    if (!window.AxiomStandardStorefront || typeof window.AxiomStandardStorefront.getCart !== 'function') {
      return Promise.resolve(null);
    }

    initialCartRequest = window.AxiomStandardStorefront.getCart()
      .then(function (cart) {
        if (cart) updateAll(cart);
        return cart;
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        initialCartRequest = null;
      });

    return initialCartRequest;
  }

  function initialize(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var hasInstance = Boolean(
      (root.matches && root.matches(selector)) || root.querySelector(selector)
    );
    if (!hasInstance) return;
    if (document.querySelector(selector + '[data-atc-preview]')) bindPreview();

    if (latestCart) {
      updateAll(latestCart, root);
      return;
    }
    requestInitialCart();
  }

  // ── PREVIEW ON ADD TO CART ────────────────────
  // Product page block setting: hovering or focusing Add to cart shows what the
  // product adds. Uses the cart this script already holds (or the total Liquid
  // wrote), the variant price from the product JSON and the quantity field:
  // nothing is fetched per hover. Visual only; the message stays the text for
  // assistive tech.
  var productJsonCache = new WeakMap();
  var previewBound = false;

  function previewBars(button) {
    var scope = button.closest('[data-product-root]') || button.closest('.shopify-section') || document;
    return Array.prototype.slice.call(scope.querySelectorAll(selector + '[data-atc-preview]'));
  }

  function productVariants(button) {
    var section = button.closest('.shopify-section') || document;
    var script = section.querySelector('[id^="product-json-"]');
    if (!script) return [];
    if (!productJsonCache.has(script)) {
      var variants = [];
      try { variants = JSON.parse(script.textContent).variants || []; } catch (error) {}
      productJsonCache.set(script, variants);
    }
    return productJsonCache.get(script);
  }

  function addedCents(button) {
    var form = button.form || button.closest('form');
    if (!form) return 0;
    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput ? String(idInput.value) : '';
    var variant = productVariants(button).find(function (item) {
      return String(item.id) === variantId;
    });
    if (!variant) return 0;
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
    return Number(variant.price) * quantity || 0;
  }

  function showPreview(instance, adding) {
    var threshold = thresholdInCartCurrency(instance);
    if (threshold <= 0 || adding <= 0) return;
    var total = latestCart ? cartTotalCents(latestCart) : Number(instance.dataset.cartTotal || 0);
    if (total >= threshold) return;
    var projected = total + adding;
    var label = instance.querySelector('[data-free-shipping-preview]');
    if (label) {
      label.innerHTML = projected >= threshold
        ? String(instance.dataset.previewReached || instance.dataset.successTemplate || '')
        : replaceAmount(instance.dataset.progressTemplate, formatMoney(threshold - projected));
    }
    instance.style.setProperty('--free-shipping-preview', Math.min(100, projected / threshold * 100) + '%');
    instance.classList.add('is-previewing');
  }

  function hidePreview(instance) {
    instance.classList.remove('is-previewing');
  }

  function previewButton(target) {
    var button = target && target.closest ? target.closest('[data-atc-btn]') : null;
    return button && !button.disabled ? button : null;
  }

  function bindPreview() {
    if (previewBound) return;
    previewBound = true;
    document.addEventListener('pointerover', function (event) {
      if (event.pointerType === 'touch') return;
      var button = previewButton(event.target);
      if (!button || button.contains(event.relatedTarget)) return;
      var bars = previewBars(button);
      if (!bars.length) return;
      var adding = addedCents(button);
      bars.forEach(function (bar) { showPreview(bar, adding); });
    });
    document.addEventListener('pointerout', function (event) {
      var button = previewButton(event.target);
      if (!button || button.contains(event.relatedTarget)) return;
      if (button.matches(':focus-visible')) return;
      previewBars(button).forEach(hidePreview);
    });
    document.addEventListener('focusin', function (event) {
      var button = previewButton(event.target);
      if (!button || !button.matches(':focus-visible')) return;
      var bars = previewBars(button);
      if (!bars.length) return;
      var adding = addedCents(button);
      bars.forEach(function (bar) { showPreview(bar, adding); });
    });
    document.addEventListener('focusout', function (event) {
      var button = previewButton(event.target);
      if (button) previewBars(button).forEach(hidePreview);
    });
    // Adding (or a sold-out variant) ends the preview; the cart update fills the bar.
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.querySelector && form.querySelector('[data-atc-btn]')) {
        previewBars(form.querySelector('[data-atc-btn]')).forEach(hidePreview);
      }
    }, true);
  }

  function handleCartEvent(event) {
    if (!event || !event.promise || typeof event.promise.then !== 'function') return;
    event.promise.then(function (result) {
      if (result && result.cart) updateAll(result.cart);
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    initialize(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
  document.addEventListener('shopify:cart:lines-update', handleCartEvent);
  document.addEventListener('shopify:cart:note-update', handleCartEvent);
  document.addEventListener('shopify:cart:discount-update', handleCartEvent);
  // Re-rendered cart markup comes from Liquid, which leaves a converted threshold empty.
  document.addEventListener('cart:drawer:rendered', function (event) {
    updateAll(null, event.detail && event.detail.drawer);
  });
  document.addEventListener('cart:page:rendered', function (event) {
    updateAll(null, event.detail && event.detail.cartPage);
  });

  window.AxiomFreeShippingBar = {
    initialize: initialize,
    update: updateAll
  };
})();
